import title_img from './title_img.vue'

const timgname = {
  install(Vue){
    Vue.component('timgname',title_img)
  }
}
export default timgname;



// WEBPACK FOOTER //
// ./src/components/titleimg/index.js